import { urlBase } from "../config";
import axiosInstance from "../../services/config/axiosinstance";

const baseUrl = `${urlBase}/buttons-portal-events`;

async function create(button) {
  const config = {
    method: "post",
    url: `${baseUrl}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: button,
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

async function deleteButton(id) {
  const config = {
    method: "delete",
    url: `${baseUrl}/${id}`,
    headers: {
      "Content-Type": "application/json",
    },
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

async function getButtons(
  eventId,
  limit = 100,
  offset = 1,
  columnSearch = "",
  search = ""
) {
  const config = {
    method: "get",
    url: `${baseUrl}/${eventId}/event/?${limit}&${offset}&${columnSearch}&${search}`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

async function edit(data, id) {
  const config = {
    method: "put",
    url: `${baseUrl}/${id}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

async function setButtonsOrder(data) {
  const config = {
    method: "post",
    url: `${baseUrl}/order`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };
  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export { create, edit, getButtons, setButtonsOrder, deleteButton };
